interface ProfileSectionData {
  label: string
  body: string[]
}

interface ProfileSectionProps {
  label: string
  title: string
  sections: ProfileSectionData[]
  imageUrlXl: string
  imageUrlLg: string
  imageUrlMd: string
  imageUrlSm: string
  imageAlt: string
}

export function ProfileSection({
  label,
  title,
  sections,
  imageUrlXl,
  imageUrlLg,
  imageUrlMd,
  imageUrlSm,
  imageAlt,
}: ProfileSectionProps) {
  return (
    <section
      id="profile"
      data-marketing-section=""
      className="
        relative w-full overflow-hidden bg-[#2498fe]
        py-14 pb-[352px] min-h-[948px]
        md:py-14 md:pb-14 md:min-h-0
        lg:py-[100px]
        2xl:py-[175px]
      "
    >
      {/* Background image — 4 breakpoint swap */}
      <picture>
        <source media="(min-width: 1920px)" srcSet={imageUrlXl} />
        <source media="(min-width: 1280px)" srcSet={imageUrlLg} />
        <source media="(min-width: 768px)" srcSet={imageUrlMd} />
        <img
          src={imageUrlSm}
          alt={imageAlt}
          className="absolute inset-0 w-full h-full object-cover object-center pointer-events-none select-none"
        />
      </picture>

      {/* Profile content overlay — Figma mobile (node 194:3684) centers all text;
          desktop (node 37:10168) left-aligns over the photo gradient */}
      <div className="relative z-10 mx-auto max-w-[1136px] px-6 md:px-10 lg:px-10 xl:px-0">
        <div className="flex flex-col gap-14 items-center lg:items-start">
          {/* Title block */}
          <div className="flex flex-col gap-2 w-full lg:w-[444px]">
            <p className="text-white font-semibold text-[20px] lg:text-[24px] leading-[1.4] tracking-[-0.6px] text-center lg:text-left">
              {label}
            </p>
            <h2 className="text-white font-bold text-[28px] lg:text-[40px] leading-[1.2] tracking-[-0.6px] text-center lg:text-left">
              {title}
            </h2>
          </div>

          {/* Profile detail paragraphs */}
          <div className="flex flex-col gap-6 w-full">
            {sections.map((sec, i) => (
              <p
                key={sec.label}
                className={`
                  text-white whitespace-pre-line tracking-[-0.6px] leading-[1.5] text-center lg:text-left
                  ${
                    i === 0
                      ? 'text-[18px] lg:text-[20px] font-semibold'
                      : 'text-[18px] font-normal'
                  }
                `}
              >
                {sec.body.join('\n')}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
